import React, { useState } from 'react';
import Header from '../../components/common/global-top-bar';
import Spinner from '../../components/common/spinner';
import Searchbar from '../../components/common/searchbar';
import { Paginator } from '../../components/common/paginator';
import { Headeroptions } from './user-safety-constants';
import SwitchBar from '../../components/switch-bar';
import Modal from '../../components/common/modal';
import { useConnectionBlocks, useRemoveConnectionBlock } from '../../hooks/useConnectionBlocks';

type state = {
  showModal: boolean;
  resourceId: number;
  name: string;
};

type FilterProps = {
  fetchData: (data: any) => void;
  count: number | undefined;
  filters: { page: number; limit: number; search?: string };
};

const Filters: React.FunctionComponent<FilterProps> = ({ count = 0, fetchData, filters }): JSX.Element => {
  return (
    <div className="gray-border-line bg-gray-background-light flex h-10 w-full items-center justify-between border-b px-7">
      <div className="w-1/3">
        <div className="flex h-8 w-full">
          <div className="w-3/4">
            <Searchbar
              search={(data) => {
                fetchData({ ...filters, page: 1, search: data });
              }}
            />
          </div>
        </div>
      </div>
      <div className="w-1/4">
        <Paginator
          count={count}
          limit={filters.limit}
          currentPage={filters.page}
          handlePageChange={(page) => fetchData({ ...filters, page })}
        />
      </div>
      <div className="w-1/3"></div>
    </div>
  );
};

const defaultState = {
  showModal: false,
  resourceId: 0,
  name: '',
};

const CallerBlockList: React.FunctionComponent = (): JSX.Element => {
  const [filters, setfilters] = useState<any>({ page: 1, limit: 25 });
  const [state, setState] = useState<state>(defaultState);
  const [deleteReason, setDeleteReason] = useState<string>('');
  const fetchData = (filter: any) => {
    setfilters(filter);
  };

  const { data, isLoading } = useConnectionBlocks({
    page: filters?.page || 1,
    limit: filters?.limit || 5,
    search: filters?.search || '',
  });
  const removeMutation = useRemoveConnectionBlock();

  const deleteBlackList = () => {
    if (!state.resourceId) return;
    removeMutation.mutate({ id: state.resourceId, reason: deleteReason });
    setState(defaultState);
  };

  return (
    <div>
      <Header heading={'Safety'} />
      <SwitchBar heading={Headeroptions} position={2} />

      <Filters
        count={data?.count}
        fetchData={fetchData}
        filters={{ page: filters.page, limit: filters.limit, search: filters.search }}
      />

      <div className="max-window-height overflow-y-auto pb-10">
        <div className="w-full px-7">
          {(isLoading || removeMutation.isLoading) && <Spinner />}
          <div className="text-gray-dark sticky mb-2 grid h-12 w-full grid-cols-12 items-center border-b-2 border-black text-left font-bold">
            <div className="col-span-5 font-bold">
              {/* @ts-ignore */}
              <p className="pl-10">caller and listener</p>
            </div>
          </div>
          <div className="w-full overflow-y-scroll">
            {data?.connection_blocks?.map((tag: any) => (
              <div className="text-gray-dark my-2 grid h-12 w-full cursor-pointer grid-cols-12 items-center rounded-xl border-y bg-gray-200 text-left">
                <div className="col-span-5 font-bold">
                  <p className="pl-10">{`${tag.from_user.first_name} ${tag.from_user.last_name} (${tag.from_user.display_name}) <---> ${tag.to_user.first_name} ${tag.to_user.last_name} (${tag.to_user.display_name})`}</p>
                </div>
                <div className="col-span-7 mr-2 flex items-center justify-end">
                  <button
                    className="bg-blue-primary rounded-md px-2 py-1 font-bold text-white"
                    onClick={() => {
                      setState({
                        showModal: true,
                        name: `${tag.from_user.first_name} ${tag.from_user.last_name} (${tag.from_user.display_name}) <---> ${tag.to_user.first_name} ${tag.to_user.last_name} (${tag.to_user.display_name})`,
                        resourceId: tag.id,
                      });
                      setDeleteReason('');
                    }}
                  >
                    DELETE
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Modal
        isModel={state.showModal}
        InnerComponent={
          <div
            className="inline-block transform overflow-hidden rounded-lg bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl sm:align-middle"
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                <div className="mt-3 w-full text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">
                    Remove Connection Block
                  </h3>
                  <div className="mt-2">
                    <p className="mb-3 text-sm text-gray-700">
                      Please provide a reason for removing the connection block for {state.name}.
                    </p>
                    <textarea
                      className="w-full rounded border border-gray-300 p-2 text-sm outline-none focus:ring"
                      rows={4}
                      value={deleteReason}
                      placeholder="Enter reason"
                      onChange={(e) => setDeleteReason(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button
                type="button"
                onClick={deleteBlackList}
                disabled={!deleteReason.trim()}
                className={`bg-blue-primary inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm sm:ml-3 sm:w-auto sm:text-sm ${
                  deleteReason.trim() ? '' : 'cursor-not-allowed opacity-50'
                }`}
              >
                Remove
              </button>
              <button
                type="button"
                className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:ml-3 sm:mt-0 sm:w-auto sm:text-sm"
                onClick={() => setState(defaultState)}
              >
                Cancel
              </button>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default CallerBlockList;
